import { render, staticRenderFns } from "./ErpTaskCenter.vue?vue&type=template&id=69155149"
import script from "./ErpTaskCenter.vue?vue&type=script&lang=js"
export * from "./ErpTaskCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports